// 6 色调色板 — 直接采用 Semi Design v2 自带的 scale，无需自调
// 完整 RGB 三元组来自 node_modules/@douyinfe/semi-ui/dist/css/semi.css
// Semi 已经为每个色阶在 light/dark 模式下分别定义了 0..9 档

export type PrimaryHue = 'blue' | 'violet' | 'indigo' | 'teal' | 'amber' | 'pink'

export const HUE_ORDER: PrimaryHue[] = ['blue', 'violet', 'indigo', 'teal', 'amber', 'pink']

// UI 用的色卡预览：取 light 4 档
export const HUE_SWATCH: Record<PrimaryHue, string> = {
	blue: '#3295fb',
	violet: '#885bd2',
	indigo: '#5e6fc4',
	teal: '#27c2b0',
	amber: '#f3c641',
	pink: '#ed487b'
}

// 完整 scale 数组（light/dark 各 10 档）。仅作类型参考和将来调试用，
// 实际生效由 App.scss 中预编译的类名规则完成
export const HUE_PALETTES: Record<PrimaryHue, { light: string[]; dark: string[] }> = {
	blue: {
		light: [
			'234,245,255',
			'203,231,254',
			'152,205,253',
			'101,178,252',
			'50,149,251',
			'0,100,250',
			'0,98,214',
			'0,79,179',
			'0,61,143',
			'0,44,107'
		],
		dark: [
			'5,49,112',
			'10,70,148',
			'19,92,184',
			'29,117,219',
			'41,144,255',
			'84,169,255',
			'127,193,255',
			'169,215,255',
			'212,236,255',
			'239,248,255'
		]
	},
	violet: {
		light: [
			'243,237,249',
			'226,209,244',
			'196,167,233',
			'166,127,221',
			'136,91,210',
			'106,58,199',
			'87,47,179',
			'70,37,158',
			'54,28,138',
			'40,20,117'
		],
		dark: [
			'64,27,119',
			'76,36,140',
			'88,46,160',
			'100,57,181',
			'114,70,201',
			'136,101,212',
			'162,136,223',
			'190,173,233',
			'221,212,244',
			'241,238,250'
		]
	},
	indigo: {
		light: [
			'236,239,248',
			'209,216,240',
			'167,179,225',
			'128,144,211',
			'94,111,196',
			'63,81,181',
			'51,66,161',
			'40,52,140',
			'31,40,120',
			'23,29,99'
		],
		dark: [
			'23,30,101',
			'32,41,122',
			'41,54,142',
			'52,68,163',
			'64,83,183',
			'95,113,197',
			'129,145,212',
			'167,180,226',
			'209,216,241',
			'237,239,248'
		]
	},
	teal: {
		light: [
			'228,247,244',
			'192,240,232',
			'135,224,211',
			'84,209,193',
			'39,194,176',
			'0,179,161',
			'0,149,137',
			'0,119,111',
			'0,89,85',
			'0,60,58'
		],
		dark: [
			'2,60,57',
			'4,90,85',
			'7,119,111',
			'10,149,136',
			'14,179,161',
			'51,194,176',
			'94,209,193',
			'142,225,211',
			'196,240,232',
			'230,247,244'
		]
	},
	amber: {
		light: [
			'254,251,235',
			'252,245,206',
			'249,232,158',
			'246,216,111',
			'243,198,65',
			'240,177,20',
			'200,138,15',
			'160,102,10',
			'120,70,6',
			'80,43,3'
		],
		dark: [
			'81,46,9',
			'121,75,15',
			'161,107,22',
			'202,143,30',
			'242,183,38',
			'245,202,80',
			'247,219,122',
			'250,234,166',
			'252,246,210',
			'254,251,237'
		]
	},
	pink: {
		light: [
			'253,236,239',
			'251,207,216',
			'246,160,181',
			'242,115,150',
			'237,72,123',
			'233,30,99',
			'197,19,86',
			'162,11,72',
			'126,5,58',
			'90,1,43'
		],
		dark: [
			'92,7,48',
			'128,14,65',
			'164,23,81',
			'199,34,97',
			'235,47,113',
			'239,86,134',
			'243,126,159',
			'247,168,188',
			'251,211,220',
			'253,238,241'
		]
	}
}

export function isPrimaryHue(v: unknown): v is PrimaryHue {
	return typeof v === 'string' && (HUE_ORDER as string[]).includes(v)
}
